module.exports = __webpack_public_path__ + "img/selfcleaning.4cabf527.png";